import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={20}
            height={21}
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M18.333 7.114c0 .55-.45 1-1 1H2.666c-.55 0-1-.45-1-1v-.008a3.446 3.446 0 013.45-3.45h9.758a3.46 3.46 0 013.459 3.458zM1.666 10.364v4.175a3.446 3.446 0 003.45 3.45h9.758a3.46 3.46 0 003.459-3.459v-4.166c0-.55-.45-1-1-1H2.666c-.55 0-1 .45-1 1zm5 4.833H4.999a.63.63 0 01-.625-.625.63.63 0 01.625-.625h1.667a.63.63 0 01.625.625.63.63 0 01-.625.625zm5.417 0H8.749a.63.63 0 01-.625-.625.63.63 0 01.625-.625h3.334a.63.63 0 01.625.625.63.63 0 01-.625.625z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}

export default SvgComponent